
export enum avatarType {
    user = 'user',
    base64 = 'base64',
   
}

